module.exports = __webpack_public_path__ + "img/dots-bg.2b7deae6.svg";